import { useLayoutEffect } from 'react';
import { useRouter, type AnyRouter } from '@tanstack/react-router';

function keepWindowScrollOnNextRender(router: AnyRouter) {
  router.resetNextScroll = false;
}

export function useKeepWindowScrollOnReturn(isReturning: boolean) {
  const router = useRouter();

  useLayoutEffect(() => {
    if (isReturning) keepWindowScrollOnNextRender(router);
  }, [router, isReturning]);
}
